
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/enterprise-sso",
      function () {
        return require("private-next-pages/docs/enterprise-sso.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/enterprise-sso"])
      });
    }
  